import React from "react";
import { useTranslation } from 'react-i18next';
import { AiOutlineWarning } from "react-icons/ai";
import "../../styles/DeleteConfirmationModal.css";

const RevokeConfirmationModal = ({ isOpen, onClose, onConfirm, itemName }) => {
    const { t } = useTranslation('common');

    if (!isOpen) return null;

    return (
        <div className="delete-confirmation-modal-overlay">
            <div className="delete-confirmation-modal-content">
                <div className="delete-confirmation-modal-header">
                    <div className="delete-confirmation-modal-header-info">
                        <h2 className="delete-confirmation-modal-title">{t('confirmation')}</h2>
                    </div>
                    <button className="delete-confirmation-close-btn" onClick={onClose}>✕</button>
                </div>

                <div className="delete-confirmation-modal-body">
                    <div className="delete-confirmation-message">
                        <div className="delete-confirmation-icon revoke-icon-color">
                            <AiOutlineWarning />
                        </div>
                        <p className="delete-confirmation-text">
                            {t('confirmRevokeExercise', { itemName })}
                        </p>
                        <span className="delete-confirmation-subtext">
                            {t('exerciseMarkedIncomplete')}
                        </span>
                    </div>
                </div>

                <div className="delete-confirmation-modal-footer">
                    <button className="delete-confirmation-cancel-btn" onClick={onClose}>
                        {t('cancel')}
                    </button>
                    <button className="delete-confirmation-delete-btn revoke-btn" onClick={onConfirm}>
                        {t('revokeCompletion')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default RevokeConfirmationModal;
